module.exports = __webpack_public_path__ + "static/media/onboarding_woocommerce.91ac0bc6.svg";